import React from 'react';
import '../../App.css';
function SimpleSpin() {
  return (
    <div className="lds-ring">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
}

export default SimpleSpin;
